import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import KeycloakService from "../services/KeycloakService";

const ProtectedRoute = ({ children, menuDetails, isMonitor }) => {
  const location = useLocation();
  const isLoggedIn = KeycloakService.isLoggedIn();
  switch (location.pathname) {
    case "/":
      if (menuDetails && menuDetails.length){
        if(isMonitor){
          return <Navigate to="/login" />;
        } else {
        return <Navigate to={`/${menuDetails[0].categoryName.toLowerCase().split(" ").join("-")}/${menuDetails[0]?.categoryId}`} />;
        }
      }
      return <Navigate to="/login" />
    default:
     
  }
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  } else {
    return children;
  }
};

export default ProtectedRoute;
